module.exports = __webpack_public_path__ + "static/img/categories3.62ab472.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories3.png
// module id = k+Hb
// module chunks = 1